// extracted by mini-css-extract-plugin
export var article = "case-study-module--article--5BKuJ";
export var description = "case-study-module--description--f+FXZ";
export var heading = "case-study-module--heading--XT18T";
export var soultions = "case-study-module--soultions--ylhHV";
export var title = "case-study-module--title--dqzBB";